<template>
  <el-checkbox-group ref="ElCheckboxDict" v-on="$listeners" v-bind="$attrs" @change="handdleChange">
    <template
      v-for="(slot, key) in $scopedSlots"
      :slot="key"
      slot-scope="scope"
    >
      <slot :name="key" v-bind="scope"></slot>
    </template>
    <template v-for="(slot, key) in $slots" :slot="key">
      <slot :name="key"></slot>
    </template>
    <el-checkbox
      v-for="item in list"
      :disabled="item.disabled"
      :key="item[dictConfig.format.value]"
      :label="item[dictConfig.format.value]"
      :border="border"
      :size="size"
      :name="name"
      :true-label="trueLabel"
      :false-label="falseLabel"
      :checked="checked"
      :indeterminate="indeterminate"
      >{{ item[dictConfig.format.label] }}</el-checkbox
    >
  </el-checkbox-group>
</template>
<script>
import store from "~/store/index.js"
export default {
  name: "el-checkbox-dict",
  data() {
    return {
      list: [], //数据列表
      type: "" //请求字典类型
    }
  },
  props: {
    //选中时的值
    trueLabel: {
      type: [String, Number],
      default: ""
    },
    //没有选中时的值
    falseLabel: {
      type: [String, Number],
      default: ""
    },
    //是否显示边框
    border: {
      type: Boolean,
      default: false
    },
    //Checkbox 的尺寸，仅在 border 为真时有效 medium / small / mini
    size: {
      type: String,
      default: ""
    },
    //原生 name 属性
    name: {
      type: String,
      default: ""
    },
    //设置 当前是否勾选
    checked: {
      type: Boolean,
      default: false
    },
    //设置 indeterminate 状态，只负责样式控制
    indeterminate: {
      type: Boolean,
      default: false
    },
    //是否返回键值
    keyValue: {
      type: Boolean,
      default: false
    },
    dictType: {
      type: [String, Object],
      required: true
    }, //请求的码表值
    //配置禁用选项
    disableObj: {
      type: Object
    },
    //过滤函数
    filterDataFun: {
      type: Function
    },
    //禁用函数
    disabledDataFun: {
      type: Function
    }
  },
  computed: {
    dictCodes() {
      return store.state.dictCodes
    },
    dictConfig() {
      return store.state.dictConfig
    },
    isGettingAllDictTypes() {
      return store.state.isGettingAllDictTypes
    },
    isGettingDictTypes() {
      return store.state.isGettingDictTypes
    }
  },
  watch: {
    isGettingDictTypes(val) {
      if (!val.includes(this.type)) {
        this.getDictionary_option()
      }
    },
    //请求全部字典后 重新渲染页面
    isGettingAllDictTypes(val) {
      if (!val) {
        this.getDictionary_option()
      }
    }
  },
  mounted() {
    this.getDictionary_option()
  },
  methods: {
    // 获取下拉框数据
    async getDictionary_option() {
      if (!this.dictType) {
        return
      }
      //获取该类型字典数据
      let dictData = []
      if (typeof this.dictType === "object") {
        this.type = this.dictType.type
        await store.actions.getDictDataObj(this.type)
        dictData = [].concat(this.dictCodes[this.type])
        const {
          filters,
          filterType = this.dictConfig.format.value,
          reverse = false
        } = this.dictType
        const filtersArr =
          typeof filters === "string" ? filters.split(",") : filters
        if (reverse) {
          dictData = dictData.filter((item) => {
            return !filtersArr.includes(item[filterType])
          })
        } else {
          dictData = dictData.filter((item) => {
            return filtersArr.includes(item[filterType])
          })
        }
      } else {
        this.type = this.dictType
        await store.actions.getDictDataObj(this.type)
        dictData = [].concat(this.dictCodes[this.type])
      }

      //使用函数过滤数据
      if (this.filterDataFun) {
        dictData = this.filterDataFun(dictData)
      }

      //使用函数禁用数据
      if (this.disabledDataFun) {
        dictData = this.disabledDataFun(dictData)
      }

      if (this.disableObj) {
        const {
          disableValue,
          disableType = this.dictConfig.format.value,
          reverse = false
        } = this.disableObj
        const disableList =
          typeof disableValue === "string"
            ? disableValue.split(",")
            : disableValue
        if (reverse) {
          dictData = dictData.map((item) => {
            const targetItem = JSON.parse(JSON.stringify(item))
            targetItem.disabled =
              !disableList.includes(targetItem[disableType]) ||
              targetItem.disabled
            return targetItem
          })
        } else {
          dictData = dictData.map((item) => {
            const targetItem = JSON.parse(JSON.stringify(item))
            targetItem.disabled =
              disableList.includes(targetItem[disableType]) ||
              targetItem.disabled
            return targetItem
          })
        }
      }
      this.list = dictData
    },
    // 下拉框点击事件
    handdleChange(val) {
      /* 子组件通过事件发射向父组件传递事件及参数，emit即为发射事件
        第一个参数为向父组件传递的事件名，第二个参数为向父组件传递的参数 */
      if (!this.keyValue) {
        this.$emit("dictChange", val)
        return
      }
      const itemArr = this.list.filter((item) => {
        return val.includes(item[this.dictConfig.format.value])
      })
      this.$emit("dictChange", itemArr)
    },
    getRef() {
      return this.$refs.ElCheckboxDict
    }
  }
}
</script>
